import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Multicanalidad from '../botones/multicanalidad'
import { Image } from 'cloudinary-react'

const Grid = styled.div`
  display: flex;
  border-bottom: 1px solid #f3f3f3;
  background: ${props => props.theme.colors.grisDeFondo};

  img {
    display: block;
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 30px;
  }
`

const IconContainer = styled.div`
  width: 70px;

  ${breakpoint('tablet')`
    width: 110px;
  `}

  ${breakpoint('tablet')`
    width: 130px;
  `}
`

const Text = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${props => props.theme.colors.grisExtraOscuro};
  margin: 0.5em 0;

  ${breakpoint('tablet')`
    font-size: 25px;
  `}

  ${breakpoint('desktop')`
    font-size: 30px;
  `}

  & > span {
    color: ${props => props.theme.colors.rojoBac};
  }
`

const ButtonContainer = styled.div`
  font-size: 14px;

  ${breakpoint('tablet')`
    font-size: 18px;
  `}

  ${breakpoint('tablet')`
    font-size: 25px;
  `}
`

const TextContainer = styled.div`
  margin: 0 40px 0 20px;
`

const ImageContainer = styled.div`
  position: relative;
`

const Images = [
  {
    utm:
      '?utm_source=google&utm_medium=linkad&utm_campaign=cr-core-tjc-aw-an-gg-di-te-la-llevamos-a-tu-casa&utm_content=linkads-te-la-llevamos-a-tu-casa-1',
    movil: 'hero-te-la-llevamos-blue-cash-mobile',
    desktop: 'hero-te-la-llevamos-desktop',
  },
  {
    utm:
      '?utm_source=google&utm_medium=linkad&utm_campaign=cr-core-tjc-aw-an-gg-di-te-la-llevamos-a-tu-casa&utm_content=linkads-te-la-llevamos-a-tu-casa-2',
    movil: 'hero-te-la-llevamos-millas-auto-mobile',
    desktop: 'hero-te-la-llevamos-millas-auto-desktop',
  },
]

export default ({ utm, location, multicanalidad }) => {
  const imagesUrl = 'https://res.cloudinary.com/baccredomatic/image/upload/'
  const movil = Images.find(i => i.utm === utm).movil
  const desktop = Images.find(i => i.utm === utm).desktop

  return (
    <Grid>
      <ImageContainer>
        <picture>
          <source
            srcSet={`${imagesUrl}w_270,c_fill,g_east/${movil}`}
            media="(max-width: 270px)"
          />
          <source
            srcSet={`${imagesUrl}w_334,c_fill,g_east/${movil}`}
            media="(max-width: 334px)"
          />
          <source
            srcSet={`${imagesUrl}w_550,c_fill,g_east/${movil}`}
            media="(max-width: 550px)"
          />
          <source
            srcSet={`${imagesUrl}w_680,h_420,c_fill,g_east/${desktop}`}
            media="(max-width: 680px)"
          />
          <source
            srcSet={`${imagesUrl}w_800,h_500,c_fill,g_east/${desktop}`}
            media="(max-width: 800px)"
          />
          <img
            src={`${imagesUrl}w_800,h_500,c_fill,g_east/${desktop}`}
            alt="¡Solicitá tu tarjeta de crédito desde tu celular!"
          />
        </picture>
      </ImageContainer>
      <TextContainer>
        <IconContainer>
          <Image
            cloudName="baccredomatic"
            publicId="icono-carro"
            dpr="auto"
            responsive
            width="auto"
            crop="scale"
          />
        </IconContainer>
        <Text>
          <span>¡Te llevamos tu tarjeta de crédito</span> a tu casa!
        </Text>
        <ButtonContainer>
          <Multicanalidad multicanalidad={multicanalidad} />
        </ButtonContainer>
      </TextContainer>
    </Grid>
  )
}
